"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSelectedFiltersCount = exports.getSelectedFiltersFromFilters = exports.getUniqueItems = void 0;
const typings_1 = require("../typings");
const getUniqueItems = ({ columns, rows }) => {
    const filterableColumns = [];
    columns.forEach(column => {
        if (column && column.filterable === true) {
            filterableColumns.push({ type: typings_1.TableFilterType.Filterable, value: column.name });
        }
        if (column && column.searchable === true) {
            filterableColumns.push({ type: typings_1.TableFilterType.Searchable, value: column.name });
        }
    });
    const res = {};
    rows.forEach(row => {
        filterableColumns.forEach(column => {
            if (!res[column.value] && column.type === typings_1.TableFilterType.Filterable) {
                res[column.value] = [];
            }
            if (!res[column.value] && column.type === typings_1.TableFilterType.Searchable) {
                res[column.value] = '';
            }
            if (column.type === typings_1.TableFilterType.Searchable) {
                return;
            }
            const item = row[column.value];
            if (item && Array.isArray(item)) {
                const items = item;
                items.forEach(tempItem => {
                    res[column.value].indexOf(tempItem) === -1 && res[column.value].push(tempItem);
                });
            }
            else {
                const itemValue = column.value === 'status' ? item.title : item;
                if (itemValue && res[column.value].indexOf(itemValue) === -1) {
                    res[column.value].push(itemValue);
                }
            }
        });
    });
    return res;
};
exports.getUniqueItems = getUniqueItems;
const getSelectedFiltersFromFilters = (filters) => {
    return Object.keys(filters).reduce((acc, currentValue) => {
        var _a, _b;
        const selectedFilters = [];
        if (filters[currentValue].type === typings_1.TableFilterType.Filterable) {
            (_b = (_a = filters[currentValue]) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.forEach((item, i) => {
                if (item.selected) {
                    selectedFilters.push(i);
                }
            });
        }
        if (filters[currentValue].type === typings_1.TableFilterType.Searchable) {
            selectedFilters.push('');
        }
        acc[currentValue] = selectedFilters;
        return acc;
    }, {});
};
exports.getSelectedFiltersFromFilters = getSelectedFiltersFromFilters;
const getSelectedFiltersCount = filters => {
    return Object.keys(filters).reduce((acc, currentValue) => {
        const filterItems = filters[currentValue];
        const filterItemsCount = filterItems[0] && filterItems[0] !== '' ? filterItems.length : 0;
        return acc + filterItemsCount;
    }, 0);
};
exports.getSelectedFiltersCount = getSelectedFiltersCount;
